import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const DriverAuthContext = createContext(null);

export const DriverAuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem('mr_driver_token'));
  const [driver, setDriver] = useState(null);

  useEffect(() => {
    if (!token) {
      setDriver(null);
      return;
    }
    axios
      .get(`${API}/driver/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => setDriver(data))
      .catch(() => {
        localStorage.removeItem('mr_driver_token');
        setToken(null);
        setDriver(null);
      });
  }, [token]);

  const login = async (phone, password) => {
    try {
      const { data } = await axios.post(`${API}/driver/login`, { phone, password });
      localStorage.setItem('mr_driver_token', data.access_token);
      setToken(data.access_token);
      setDriver(data.driver);
      return { ok: true };
    } catch (err) {
      return { ok: false, error: err?.response?.data?.detail || 'Login failed' };
    }
  };

  const applyToken = (accessToken, driverDoc) => {
    localStorage.setItem('mr_driver_token', accessToken);
    setToken(accessToken);
    if (driverDoc) setDriver(driverDoc);
  };

  const logout = () => {
    localStorage.removeItem('mr_driver_token');
    setToken(null);
    setDriver(null);
  };

  const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};

  return (
    <DriverAuthContext.Provider value={{ token, driver, login, applyToken, logout, authHeaders }}>
      {children}
    </DriverAuthContext.Provider>
  );
};

export const useDriverAuth = () => useContext(DriverAuthContext);
